import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex flex-col items-center justify-center mb-6">
  <img
    src="/lakeelogo.png" 
    alt="Lakeee Logo"
    className="w-40 h-45 object-contain" 
  />
  {/* <p className="mt-4 text-sm text-muted-foreground">
    API Documentation Portal
  </p> */}
</div>



      {/* Welcome Message */}
      <div className="space-y-2">
        <h2 className="text-l font-semibold text-foreground">API Documentation Portal</h2>
        <p className="text-muted-foreground">
          Sign in to access your API documentation and management tools
        </p>
      </div>

      {/* Role Information */}
      {/* <div className="mt-6 p-4 bg-accent/5 border border-accent/20 rounded-lg">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <Icon name="Users" size={16} className="text-accent" />
          <span className="text-sm font-medium text-accent">Multi-Role Access</span>
        </div>
        <p className="text-xs text-muted-foreground">
          Administrators get full management access, while clients can access documentation and manage API keys
        </p>
      </div> */}
    </div>
  );
};

export default LoginHeader;